import {
	IndividualInvestorSettings,
	InvestmentVehicleSettings,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/types.ts';

interface RequirementRow<TKey> {
	key: TKey;
	translationKey: string;
	defaults?: { label: string; description: string };
}

export const INDIVIDUAL_ROWS: RequirementRow<keyof IndividualInvestorSettings>[] = [
	{ key: 'bankAccountDetails', translationKey: 'investor_data.bank_account' },
	{ key: 'taxResidence', translationKey: 'investor_data.tax_residence' },
	{ key: 'taxIdentificationNumber', translationKey: 'investor_data.tin' },
	{ key: 'placeOfBirth', translationKey: 'investor_data.place_of_birth' },
	{
		key: 'countryOfBirth',
		translationKey: 'investor_data.country_of_birth',
		defaults: {
			label: 'Country of birth',
			description: 'Require investors to provide their country of birth',
		},
	},
	{ key: 'employeeId', translationKey: 'investor_data.employee_id' },
	{ key: 'citizenship', translationKey: 'investor_data.citizenship' },
];

export const VEHICLE_ROWS: RequirementRow<keyof InvestmentVehicleSettings>[] = [
	{ key: 'bankAccountDetails', translationKey: 'investor_data.bank_account' },
	{ key: 'controllingPartyInfo', translationKey: 'investor_data.controlling_party' },
];
